var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAiChatWhiteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 134,
    height: 134,
    viewBox: "0 0 134 134",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 66.5737,
    cy: 66.5737,
    r: 66.5737,
    fill: "#EEEEEE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.2529 78.2816H47.0581C49.2135 78.2816 50.9607 80.0288 50.9607 82.1842V89.9894C50.9607 92.1447 49.2135 93.892 47.0581 93.892H39.2529V66.5738C39.2529 51.4864 51.4837 39.2556 66.5711 39.2556C81.6585 39.2556 93.8893 51.4864 93.8893 66.5738V93.892H86.0841C83.9288 93.892 82.1815 92.1447 82.1815 89.9894V82.1842C82.1815 80.0288 83.9288 78.2816 86.0841 78.2816H93.8893",
    stroke: "#710D10",
    strokeWidth: 6.50433,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiChatWhiteIcon);
export default __webpack_public_path__ + "static/media/ai-chat-white-icon.b1b4e0751b12aade8001dd8ddd31ac06.svg";
export { ForwardRef as ReactComponent };